// Limpeza de trajectos GPS brutos vindos do Traccar.
//
// O histórico do Traccar costuma trazer fixes lixo — latitude/longitude
// a (0,0) ou saltos para o outro lado do mundo — que inflam distâncias
// e desvios para valores absurdos. cleanTrail descarta:
//   • coordenadas inválidas ou fora de gama;
//   • "null island" (~0,0);
//   • outliers — pontos a mais de 400 km da MEDIANA do trajecto (a
//     mediana é robusta: uma minoria de fixes lixo não a desloca).
// Devolve os pontos válidos ordenados por tempo.

function haversineM(a, b) {
  if (!a || !b) return Infinity;
  const R = 6371000;
  const toRad = (d) => d * Math.PI / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const x = Math.sin(dLat / 2) ** 2
    + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}

export function cleanTrail(raw) {
  let pts = (raw || []).filter(p =>
    p && Number.isFinite(p.lat) && Number.isFinite(p.lng) &&
    Math.abs(p.lat) <= 90 && Math.abs(p.lng) <= 180 &&
    !(Math.abs(p.lat) < 1 && Math.abs(p.lng) < 1)
  );
  if (pts.length >= 3) {
    const median = (arr) => {
      const s = [...arr].sort((a, b) => a - b);
      return s[Math.floor(s.length / 2)];
    };
    const centre = { lat: median(pts.map(p => p.lat)), lng: median(pts.map(p => p.lng)) };
    pts = pts.filter(p => haversineM(p, centre) < 400000);
  }
  pts.sort((a, b) =>
    new Date(a.fixTime || a.timestamp || 0) - new Date(b.fixTime || b.timestamp || 0));
  return pts;
}

export { haversineM };
